import { Injectable } from '@angular/core';
import { IMenuGroup, ISubMenuItem } from '../_shared/models';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    wasClicked = false;

    hasItems(menuGroup: IMenuGroup): boolean {
        const hasItems = menuGroup.columns
            ? menuGroup.columns.some((col: ISubMenuItem[]) => col.length > 0)
            : false;

        const hasHighlights = menuGroup.highlightItems
            ? menuGroup.highlightItems.length > 0
            : false;

        return hasItems || hasHighlights;
    }
}
